export default __webpack_public_path__ + "static/media/mg-dropdown.925640d0.webp";